import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import {
  CardNameToOptionsMap,
  DashboardCardNameEnum,
  DashboardCardTemplateTypeEnum,
  DATA_E2E_KEY,
  IStyledAttributes,
  PLURAL_KEY,
} from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const EmptyContentStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dashboard-card-empty-chart-content",
})`
  background-color: ${rydeColors.white};
  position: relative;
  top: 40%;
  font-size: 18px;
  transform: translateY(-50%);
  justify-items: center;
  text-align: center;
  align-items: center;
`;

export interface IEmptyGraphContentMessageProps {
  cardType: DashboardCardTemplateTypeEnum;
  cardName: DashboardCardNameEnum;
}

export const CardEmptyGraphContentMessageTemplate: FC<
  IEmptyGraphContentMessageProps
> = ({ cardName, cardType }) => {
  const { t } = useTranslation();
  const entity = CardNameToOptionsMap[cardName].titleCardSettings.entity;
  return (
    <EmptyContentStyled>
      {t("errors.dashboardEmptyGraphMessage", {
        entities: t(`${entity}.${PLURAL_KEY}`),
        title: t(`dashboard.${cardName}.TITLE`),
      })}
    </EmptyContentStyled>
  );
};
